"use client";

import { Box, Container } from "@chakra-ui/react";
import { BlogPosts } from "../BlogPosts";
import "../../_styles/landing-redesign.css";
import { LandingAbout } from "./LandingAbout";
import { LandingCtaFinal } from "./LandingCtaFinal";
import { LandingCursor } from "./LandingCursor";
import { LandingEvalStrip } from "./LandingEvalStrip";
import { LandingFaqRedesign } from "./LandingFaqRedesign";
import { LandingFeaturesDark } from "./LandingFeaturesDark";
import { LandingHero } from "./LandingHero";
import { LandingRewards } from "./LandingRewards";
import { LandingTestimonialBlock } from "./LandingTestimonialBlock";
import { LandingTicker } from "./LandingTicker";
import { LandingWhyBento } from "./LandingWhyBento";
import { Header } from "../Header";
import { Footer } from "../Footer";

export function LandingPageRedesign() {
  return (
    <Box
      className="landing-redesign-root"
      minH="100dvh"
      display="flex"
      flexDirection="column"
      bg="neutral.50"
      color="neutral.900"
      overflowX="hidden"
    >
      <LandingCursor />

      <Header headerColor="neutral.900" headerBgColor="neutral.50" />

      <Box as="main" role="main" flex={1} pt="64px">
        <LandingHero />
        <LandingTicker />
        <LandingRewards />
        <Container
          maxW="8xl"
          mx="auto"
          px={{ base: 4, md: 0 }}
          py={{ base: 6, md: 32 }}
        >
          <LandingEvalStrip />
        </Container>
        <LandingFeaturesDark />
        <LandingWhyBento />
        <LandingAbout />
        <LandingTestimonialBlock />
        <LandingFaqRedesign />
        <Container maxW="8xl" mx="auto" px={{ base: 4, md: 0 }}>
          <Box id="blog" py={{ base: 8, md: 12 }}>
            <BlogPosts />
          </Box>
        </Container>
        <LandingCtaFinal />
      </Box>
      <Container maxW="full" mx="auto" px={{ base: 4, md: 0 }} bg="neutral.900">
        <Footer theme="dark" />
      </Container>
    </Box>
  );
}
